import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../Contexts/AuthContext";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import logoutIcon from "../../Images/Icons/logoutIcon.png";
import { globalServices } from "../../Services";
import { userServices } from "../../Services/user.service";
import { Tabs, Tab } from "react-bootstrap";
import { roles } from "../../Config/Roles";
import axios from "axios";
import { apiUrl } from "../../Config/Url";
import { useLocation } from "react-router-dom";
import ChangePassModal from "./ChangePassModal";

const Toolbar = (props) => {
  const {
    changeLanguage,
    selectedLanguageId,
    locName,
    locTenant,
    locStore,
    locPos,
    locUser,
    setUpdatePerformances,
    unfiscalizedBillCount,
  } = useContext(GlobalContext);
  const {
    logout,
    name,
    email,
    tenantId,
    multipleTenant,
    userId,
    roleId,
    tenantName,
    setTenant,
    setTenantName,
  } = useContext(AuthContext);
  const location = useLocation();
  const { master, admin, support } = roles;
  const { t: translator } = useTranslation();
  const [show, setShow] = useState(false);
  const [showUserData, setShowUserData] = useState(false);
  const [showChangePass, setShowChangePass] = useState(false);
  const [user, setUser] = useState([]);
  const [showSettings, setShowSettings] = useState(false);
  const [key, setKey] = useState("statistics");
  const [widgetsPer, getWidgetsPer] = useState([]);
  const [widgetsStat, getWidgetsStat] = useState([]);
  const [setWidgets, setWidgetsAction] = useState({});
  let init = localStorage.getItem("liveReload");
  const [checkLive] = useState(init === "false" ? false : true);

  var firstName = name.split(" ")[0];

  const [languages, setLanguages] = React.useState(null);
  const [locKey, setLocKey] = useState(1);
  React.useEffect(() => {
    globalServices.getLanguages().then((data) => {
      console.log("data", data);
      setLanguages(data.data);
    });

    userServices
      .getById(userId)
      .then((res) => setUser(res.data))
      .catch((err) => console.log(err));

    switch (locName) {
      case "tenants":
        setLocKey(locTenant);
        break;
      case "stores":
        setLocKey(locStore);
        break;
      case "pos":
        setLocKey(locPos);
        break;
      case "users":
        setLocKey(locUser);
        break;
      default:
        setLocKey("0");
        break;
    }
  }, [locName, locTenant, locStore, locPos, locUser]);

  const showWidgetsPerformance = () => {
    globalServices
      .getWidgetsPerformance()
      .then((res) => {
        getWidgetsPer(res.data.data);
      })
      .catch((err) => console.log(err));
  };

  const showWidgetsStatistics = () => {
    globalServices
      .getWidgetsStatistics()
      .then((res) => {
        getWidgetsStat(res.data.data);
      })
      .catch((err) => console.log(err));
  };

  const checkboxChange = (event) => {
    const { name, checked, id } = event.target;
    setWidgetsAction({ ...setWidgets, [id]: checked });
  };

  const handleSubmitWidgets = () => {
    axios
      .put(`${apiUrl}/Widget`, { setWidgets })
      .then((res) => {
        setShowSettings(false);
        showWidgetsPerformance();
        showWidgetsStatistics();
        setUpdatePerformances(new Date());
        localStorage.setItem("liveReload", checkLive);
      })
      .catch((err) => {
        console.log("err", err.response);
      });
  };

  return (
    <>
      <div
        className="container-fluid"
        style={{ background: "#f8f8f8", height: 45 }}
      >
        <ul className="pl-2 py-2">
          {props.showHome ? (
            <div
              className="row bcrumb float-left pl-2"
              style={{ listStyleType: "none" }}
            >
              {props.showHome ? (
                <li>
                  <Link
                    to={
                      [master, admin, support].includes(Number(roleId))
                        ? "/"
                        : `/tenants/${tenantId}`
                    }
                  >
                    {/* <img
                      src={homeIcon}
                      alt="Home icon"
                      style={{ width: "19px" }}
                    /> */}
                    <span
                      className="icon icon-home my-second-step"
                      style={{
                        color: "#333",
                        fontWeight: "500",
                        fontSize: 18,
                      }}
                    ></span>
                  </Link>
                </li>
              ) : (
                ""
              )}
              {locName != "" ? (
                <>
                  <li className="ml-0" style={{ paddingTop: 2 }}>
                    /
                  </li>
                  <li className="ml-0" style={{ paddingTop: 2 }}>
                    <Link className="bcrumb-item" to={`/${locName}`}>
                      {translator(locName)}
                    </Link>
                  </li>
                </>
              ) : null}

              {locKey != "0" ? (
                <>
                  <li className="ml-0" style={{ paddingTop: 2 }}>
                    /
                  </li>
                  <li className="ml-0" style={{ paddingTop: 2 }}>
                    <Link className="bcrumb-item" to={`/${locName}/${locKey}`}>
                      {translator("Toolbar-Details")}
                    </Link>
                  </li>
                </>
              ) : null}

              {props.show ? (
                props.currentName ? (
                  <>
                    <li className="ml-0" style={{ paddingTop: 2 }}>
                      /
                    </li>
                    <li className="ml-0" style={{ paddingTop: 2 }}>
                      {translator(props.currentName)}
                    </li>
                  </>
                ) : null
              ) : null}
            </div>
          ) : null}

          <p id="tenantName">
            {multipleTenant == "true" && tenantId != "null"
              ? `${translator("Selected-Tenant")}: ${tenantName}`
              : ""}
          </p>

          <div
            className="row menu float-right pr-4"
            style={{
              listStyleType: "none",
              position: "absolute",
              right: 20,
              top: 84,
            }}
          >
            {unfiscalizedBillCount > 0 ? (
              <Link to="/invoices-invoicesUnfiscalizedAccounts">
                <li className="unfiscalized-bills d-flex align-items-center text-dark ">
                  <span>{translator("Unfiscalized-Bills")}</span>
                  <span className="badge badge-danger ml-1">
                    {unfiscalizedBillCount}
                  </span>{" "}
                </li>
              </Link>
            ) : null}

            <li className="dropdown dd">
              <div className="dropdown">
                <span
                  className="dropdown-toggle text-dark collapsed"
                  role="button"
                  id="dropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {selectedLanguageId &&
                    languages &&
                    languages.find((l) => l.id == selectedLanguageId).shortName}
                </span>
                {languages && (
                  <div
                    className="dropdown-menu nav-dd-menu"
                    aria-labelledby="dropdownMenuLink"
                  >
                    {languages
                      .filter((l) => l.id != selectedLanguageId)
                      .map((lng) => (
                        <button
                          key={lng.id}
                          className="dropdown-item"
                          onClick={(e) => {
                            e.preventDefault();
                            changeLanguage(lng.id);
                          }}
                        >
                          {lng.name}
                        </button>
                      ))}
                  </div>
                )}
              </div>
            </li>

            {[master, admin, support].includes(Number(roleId)) ? (
              <li className="dd">
                {location.pathname != "/" ? (
                  ""
                ) : (
                  <div className="dropdown">
                    <a
                      className="text-dark"
                      title={translator("SettingsIcon-Title")}
                      style={{ cursor: "pointer" }}
                    >
                      <span
                        className="icon icon-settings"
                        onClick={() => {
                          setShowSettings(true);
                          showWidgetsPerformance();
                          showWidgetsStatistics();
                        }}
                      ></span>{" "}
                      {""}
                    </a>
                  </div>
                )}
              </li>
            ) : (
              ""
            )}

            <li className="dd">
              <div className="dropdown my-third-step">
                <a
                  className="dropdown-toggle text-dark collapsed"
                  role="button"
                  id="dropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="icon icon-user-account"></span> {""}
                  {firstName}
                </a>

                <div
                  className="dropdown-menu nav-dd-menu"
                  aria-labelledby="dropdownMenuLink"
                >
                  <p className="dropdown-item">
                    <strong>{name}</strong>
                    <br />
                    {email}
                  </p>

                  <a
                    onClick={() => setShowUserData(true)}
                    className="dropdown-item text-info"
                  >
                    {translator("Toolbar-User-Info")}
                  </a>

                  <a
                    onClick={() => setShowChangePass(true)}
                    className="dropdown-item text-info"
                  >
                    {translator("ChangePass")}
                  </a>

                  <a
                    style={{ marginLeft: "20px", marginTop: "20px" }}
                    className="btn btn-outline-secondary"
                    onClick={() => setShow(true)}
                  >
                    {translator("Toolbar-Dropdown-Logout")}
                  </a>
                </div>
              </div>
            </li>
            {multipleTenant === "true" ? (
              <li>
                <span
                  className="text-dark"
                  onClick={() => {
                    setTenant(null);
                    setTenantName(null);
                    window.location.href = "/switch-tenant";
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <span className="icon icon-synchronize"></span> {""}
                  <span className="mob-hidden">
                    {translator("Toolbar-SwitchTenant")}{" "}
                  </span>
                </span>
              </li>
            ) : null}
          </div>
        </ul>
      </div>

      <Modal
        scrollable={true}
        show={showSettings}
        backdrop="static"
        keyboard={false}
        centered
        size={"s"}
      >
        <Modal.Header>
          <Modal.Title>
            <span
              className="icon icon-tools menu-icon"
              style={{ fontWeight: "500", fontSize: 23 }}
            ></span>
            &nbsp;
            {translator("Toolbar-SettingsModal-Title")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => {
              setKey(k);
            }}
          >
            <Tab
              style={{ height: "510px" }}
              key="statistics"
              eventKey="statistics"
              title={translator("Tab-Statistics")}
            >
              <div style={{ marginTop: "20px" }} className="col-lg-12">
                <p style={{ fontSize: "16px" }}>
                  <span className="icon icon-information"></span>{" "}
                  {translator("Toolbar-PerformanceTab-ModalText")}
                </p>
                {/* <div className="form-group">
                  <label className="labelCont">
                    <input
                      name="reload"
                      onChange={(event) => {
                        setCheckLive(event.target.checked);
                      }}
                      type="checkbox"
                      defaultChecked={checkLive}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span style={{ fontSize: "15px" }} className="Data">
                    <i className="fas fa-sync"></i> {translator("LiveReload")}
                  </span>
                </div> */}
                {widgetsStat &&
                  widgetsStat.map((w) => (
                    <div className="form-group">
                      <label className="labelCont">
                        <input
                          name={w.cardKey}
                          id={w.widgetId}
                          onChange={checkboxChange}
                          type="checkbox"
                          defaultChecked={w.isActive}
                        />
                        <span className="checkmark"></span>
                      </label>
                      <span style={{ fontSize: "15px" }} className="Data">
                        {translator(w.cardKey)}
                      </span>
                    </div>
                  ))}
              </div>
            </Tab>
            <Tab
              style={{ height: "510px" }}
              key="performances"
              eventKey="performances"
              title={translator("Tab-Performances")}
            >
              <div style={{ marginTop: "20px" }} className="col-lg-12">
                <p style={{ fontSize: "16px" }}>
                  <span className="icon icon-information"></span>{" "}
                  {translator("Toolbar-PerformanceTab-ModalText")}
                </p>
                {widgetsPer &&
                  widgetsPer.map((w) => (
                    <div className="form-group">
                      <label className="labelCont">
                        <input
                          name={w.cardKey}
                          id={w.widgetId}
                          onChange={checkboxChange}
                          type="checkbox"
                          defaultChecked={w.isActive}
                        />
                        <span className="checkmark"></span>
                      </label>
                      <span style={{ fontSize: "15px" }} className="Data">
                        {translator(w.cardKey)}
                      </span>
                    </div>
                  ))}
              </div>
            </Tab>
          </Tabs>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => setShowSettings(false)}
            type="button"
            className="btn btn-outline-secondary"
          >
            {translator("General-Close")}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmitWidgets}
          >
            {translator("Btn-Save")}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showUserData} backdrop="static" keyboard={false} centered>
        <Modal.Header>
          <Modal.Title>
            <span
              className="icon icon-user-account menu-icon"
              style={{ fontWeight: "500", fontSize: 23 }}
            ></span>
            &nbsp; {translator("Toolbar-UserDataModal-Title")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="tenantDataModalText">
            <span className="tenantData">
              {translator("Toolbar-UserDataModal-Name")}
            </span>
            <p>
              <strong className="DataStrong">{user.realName}</strong>
            </p>
            <span className="Data">
              {translator("Toolbar-UserDataModal-Role")}
            </span>
            <p>
              <strong className="DataStrong">{user.roleName}</strong>
            </p>
            <hr />
            <span className="Data">
              {translator("Toolbar-UserDataModal-Phone")}
            </span>
            <p>
              <strong className="DataStrong">{user.phone}</strong>
            </p>
            <span className="Data">Email</span>
            <p>
              <strong className="DataStrong">{user.email}</strong>
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => setShowUserData(false)}
            type="button"
            className="btn btn-primary"
          >
            {translator("General-Close")}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} backdrop="static" keyboard={false} centered>
        <Modal.Header>
          <Modal.Title>
            <img src={logoutIcon} alt="Logout icon" />
            &nbsp;{translator("Toolbar-ModalTitle-Logout")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{translator("Toolbar-Modal-Logout-Msg")}?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-outline-secondary"
            onClick={() => setShow(false)}
          >
            {translator("Toolbar-Modal-Cancel")}
          </button>
          <button onClick={logout} type="button" className="btn btn-primary">
            {translator("Toolbar-Logout")}
          </button>
        </Modal.Footer>
      </Modal>
      <ChangePassModal
        show={showChangePass}
        handleClose={() => setShowChangePass(false)}
      />
    </>
  );
};

export default Toolbar;
